<app-vvr-icon [dark]="false" [full]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container pb-5">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Shapefile importeren</h1>
        </div>
        <div class="controls">
            <div class="fab small" matTooltip="Terug naar overzicht" matTooltipPosition="below"
                 routerLink="/management">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>

    <form [formGroup]="importForm">
        <div class="row">
            <div class="col-6">
                <ng-select formControlName="customer_area_id" (change)="onCustomerAreaChange()" [items]="customerAreas"
                           bindLabel="name" bindValue="id" placeholder="Selecteer klantgebied">
                </ng-select>
            </div>

            <div class="col-6" *ngIf="importForm.get('customer_area_id')?.value">
                <ng-select formControlName="inspection_id" [items]="inspections" bindLabel="name" bindValue="id"
                           placeholder="Selecteer inspectie" [addTag]="addNewInspection" addTagText="Nieuwe inspectie toevoegen">
                </ng-select>
            </div>
        </div>

        <div *ngIf="importForm.get('customer_area_id')?.value && importForm.get('inspection_id')?.value">
            <input #fileInput type="file" accept=".zip,.shp,.dbf,.prj,.shx" (change)="onFileSelected($event)"
                   [disabled]="features.length > 0" style="display: none;"/>
            <button mat-raised-button color="primary" (click)="fileInput.click()" [disabled]="features.length > 0">
                <i class="fas fa-upload"></i> {{selectedFileName || 'Selecteer Shapefile ZIP'}}
            </button>

            <div *ngIf="shapefileCombinations.length > 0" class="combinations-section pt-3">
                <h5>Inhoud shapefile</h5>
                <p>Selecteer de delen uit het shapefile die je wilt importeren:</p>

                <mat-selection-list #shapefileList [multiple]="true" [disabled]="features.length > 0"
                                    (selectionChange)="onSelectionChange($event)" class="combinations-selection-list">

                    <mat-list-option checkboxPosition="before" *ngFor="let combination of shapefileCombinations"
                                     [value]="combination" [selected]="combination.selected" class="combination-option">

                        <div class="combination-content">
                            <div class="combination-header">
                                <span class="combination-name">{{combination.name}}</span>
                                <span class="combination-files">
                                    <span *ngIf="combination.hasShp" class="file-type shp">SHP</span>
                                    <span *ngIf="combination.hasDbf" class="file-type dbf">DBF</span>
                                    <span *ngIf="combination.hasPrj" class="file-type prj">PRJ</span>
                                    <span *ngIf="combination.hasShx" class="file-type shx">SHX</span>
                                </span>
                            </div>
                        </div>

                    </mat-list-option>
                </mat-selection-list>

                <div class="selection-actions">
                    <ng-container *ngIf="features.length < 1">
                        <button mat-button (click)="selectAllCombinations()">
                            Selecteer Alles
                        </button>
                        <button mat-button (click)="deselectAllCombinations()">
                            Deselecteer Alles
                        </button>
                        <button mat-raised-button color="accent" (click)="processSelectedCombinations()"
                                [disabled]="selectedCombinations.length === 0">
                            Importeer geselecteerde delen ({{selectedCombinations.length}})
                        </button>
                    </ng-container>
                    <button *ngIf="features.length > 0" mat-raised-button color="accent" (click)="openDataDialog()">
                        <i class="fas fa-table"></i>
                        Bekijk data ({{features.length}} features)
                    </button>
                </div>
            </div>

            <div *ngIf="features.length > 0">
                <h5>Punaisekoppeling</h5>
                <p>Map de waarden uit de shapefile naar het juiste veld in een punaise: </p>
                <div class="form-check mb-3">
                    <mat-checkbox formControlName="autoFillLocationFields">
                        Automatisch locatievelden vullen (straat, postcode, huisnummer, plaats) op basis van GPS-coördinaten
                    </mat-checkbox>
                </div>

                <div formArrayName="pushpinMappings">
                    <div class="mapping" *ngFor="let control of pushpinMappingsFormArray.controls; let i = index">
                        <label>
                            {{pushpinFieldLabels.get(pushpinFields[i])?.name}}
                            <span *ngIf="automaticMappings.has('pushpin-' + i)" class="auto-mapping-badge" title="Automatisch gemapped">
                                <i class="fas fa-magic"></i>
                            </span>
                        </label>
                        <ng-select [formControl]="control" [clearable]="true" appendTo="body"
                                   placeholder="Kies een eigenschap uit de shapefile"
                                   (change)="onMappingManualChange('pushpin', i)">
                            <ng-option *ngFor="let prop of shapefileProperties" [value]="prop">
                                <b>{{prop}}</b><span class="select-option-value-info">{{prop | shapefileValueInfo: features}}</span>
                            </ng-option>
                        </ng-select>
                        <div class="hint">{{pushpinFieldLabels.get(pushpinFields[i])?.description}}</div>
                    </div>
                </div>

                <h5 class="mt-3">Punaisedeel koppeling</h5>
                <p>Map de waarden van een makeringsitem met de waarden uit de shapefile: </p>
                <div formArrayName="pushpinPartMappings">
                    <div class="mapping" *ngFor="let control of pushpinPartMappingsFormArray.controls; let i = index">
                        <label>
                            {{pushpinPartFieldLabels.get(pushpinPartFields[i])?.name}}
                            <span *ngIf="automaticMappings.has('pushpinpart-' + i)" class="auto-mapping-badge" title="Automatisch gemapped">
                                <i class="fas fa-magic"></i>
                            </span>
                        </label>
                        <ng-select [formControl]="control" [clearable]="true" appendTo="body"
                                   placeholder="Kies een eigenschap uit de shapefile"
                                   (change)="onMappingManualChange('pushpinpart', i); onMappingChange(pushpinPartFields[i])">
                            <ng-option *ngFor="let prop of shapefileProperties" [value]="prop">
                                <b>{{prop}}</b><span class="select-option-value-info">{{prop | shapefileValueInfo: features}}</span>
                            </ng-option>
                        </ng-select>
                        <div class="hint">{{pushpinPartFieldLabels.get(pushpinPartFields[i])?.description}}</div>
                    </div>
                </div>

                <!-- Standaard terugvalwaarden sectie -->
                <div *ngIf="availableDefaultFields.length > 0">
                    <h5 class="mt-3">Standaard terugvalwaarden</h5>
                    <p>Stel standaard waarden in voor velden zonder shapefile koppeling:</p>
                    <div *ngFor="let field of availableDefaultFields">
                        <div class="field-mapping" *ngIf="fieldItemsMap.get(field.items)?.length > 0">
                            <label>{{field.label}}</label>
                            <ng-select [formControlName]="field.name" [clearable]="true"
                                       [placeholder]="'Selecteer ' + field.label.toLowerCase()">
                                <ng-option *ngFor="let item of fieldItemsMap.get(field.items)" [value]="item.id">
                                    <ng-container *ngFor="let displayProp of field.displayProperty; let isFirst = first">
                                        {{item[displayProp]}}<span *ngIf="!isFirst"> </span>
                                    </ng-container>
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                </div>

                <div *ngFor="let field of mappableFields" [ngClass]="field.name + '-mapping-section'">
                    <div *ngIf="fieldMappings.get(field.name)?.size > 0">
                        <h5 class="mt-3">{{field.label}} koppeling</h5>
                        <p>Map de {{field.label.toLowerCase()}} waarden uit de shapefile: </p>
                        <div class="field-mapping"
                             *ngFor="let mapping of fieldMappings.get(field.name) | keyvalue">
                            <label>{{mapping.key}}</label>
                            <ng-select
                                [clearable]="true"
                                [placeholder]="'Selecteer ' + field.label.toLowerCase()"
                                [ngModel]="mapping.value"
                                (ngModelChange)="updateFieldMapping(field.name, mapping.key, $event)"
                                [ngModelOptions]="{standalone: true}">
                                <ng-option *ngFor="let item of fieldItemsMap.get(field.items)" [value]="item.id">
                                    <ng-container *ngFor="let displayProp of field.displayProperty; let isFirst = first">
                                        {{item[displayProp]}}<span *ngIf="!isFirst"> </span>
                                    </ng-container>
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-end mt-4">
                    <button mat-raised-button color="primary" type="submit" (click)="import()"
                            [disabled]="importing !== null || importForm.invalid">
                        <span *ngIf="importing === null">Importeren</span>
                        <span *ngIf="importing !== null">Bezig met importeren... ({{importing}}/{{totalPushpins}})</span>
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>
